import { useEffect, useState } from "react";
import { getJournalSettings } from "./api/admin/settings";
import { JournalSettings } from "../types/api/admin/settings";

export const DEFAULT_JOURNAL_SETTINGS: JournalSettings = {
    demoAccountBase: 50000,
    moneyManagementOptions: [150, 300, 500],
    challengeMoneyManagement: 2500,
};

let cached: JournalSettings | null = null;
let inflight: Promise<JournalSettings> | null = null;

export async function loadJournalSettings(): Promise<JournalSettings> {
    if (cached) return cached;
    if (!inflight) {
        inflight = getJournalSettings()
            .then((journal) => {
                cached = journal ?? DEFAULT_JOURNAL_SETTINGS;
                return cached;
            })
            .catch(() => {
                cached = DEFAULT_JOURNAL_SETTINGS;
                return cached;
            })
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
}

/** Invalide le cache après un PATCH admin Journal. */
export function invalidateJournalSettingsCache(): void {
    cached = null;
}

export function useJournalSettings(): JournalSettings {
    const [journal, setJournal] = useState<JournalSettings>(
        cached ?? DEFAULT_JOURNAL_SETTINGS
    );

    useEffect(() => {
        let cancelled = false;
        loadJournalSettings().then((next) => {
            if (!cancelled) setJournal(next);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return journal;
}
